import { useEffect } from "react";
import { useHistory, useParams } from "react-router"
import AdminMenu from "../../components/admin/menu";
import AdminPageContainer from "../../components/admin/page-container";
import useDarkLayout from "../../components/loyauts/use-dark-layout";
import useConfig from "../../modules/main/hooks/use-config";
import useLibrary from "../../modules/user/hooks/use-library";
import { getHomeRoute } from "../routes";
import LibraryForm from "./library-form";

export default function EditLibraryPage() {

    useDarkLayout();

    const { code } = useParams<{ code: string }>();
    const { library, error } = useLibrary(code);
    const history = useHistory();

    useEffect(() => {
        if (error) {
            history.replace(getHomeRoute());
        }
    }, [error, history]);

    const {isAdmin} = useConfig();

    return <AdminPageContainer>
        {isAdmin && <AdminMenu />}
        <h2>Edycja danych biblioteki: {code}</h2>
        {library && <LibraryForm library={library} />}
    </AdminPageContainer>
}
